import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-responsive-modal";
import GetAllOrderApi from "../../api/allOrderApi";
import { getAllReview, reviewAddApi } from "../../api/reviewApi";
import { SETALLORDERDATA } from "../../redux/features/AllOrder";
// import NoDataFound from "../NoDataFound/NoDataFound";
import ReviewList from "./ReviewList";
// import RenderStars from "./RenderStars";
import { BackButton } from "../../Wrapper/MyInfoWrapper";
import { SETSELECTEDSTORE } from "../../redux/features/store";
import Konsole from "../../utils/konsole/Konsole";
// getOrder();
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import GlobalButton from "../Buttons/btn2/GlobalButton";
export const reviewRefrencePageArr = ["ReviewPage", "CurrentOrder"];
import useAllApiCall from "../../hooks/useAllApiCall";
const AllReview = ({
  refrencePage,
  orderDetail,
}: {
  refrencePage: string;
  orderDetail: any;
}) => {
  Konsole.log("refrencePage", refrencePage);
  const reviewDetail = orderDetail?.review;
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { getStoreInfo } = useAllApiCall()

  const location = useLocation();

  const reduxData = useSelector((state: any) => state);
  const {
    store: { allReviewList },
  } = reduxData;
  // console.log(allReviewList,"allReviewList")
  Konsole.log("allReviewList", allReviewList, reduxData);

  const [IsModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const [rating, setRating] = useState<number>(1); // Track the rating
  const [review, setReview] = useState<string>(""); // Track the review text

  Konsole.log("orderDetail", orderDetail);

  const handleModalOpenClose = (val: boolean) => {
    if (val == true) {
      setRating(reviewDetail?.rating);
      setReview(reviewDetail?.review);
    }
    setIsModalOpen(val);
  };
  // Handle the click on a star
  const handleRating = (star: number) => {
    // Log when a star is clicked (checked or unchecked)
    Konsole.log("Star clicked:", star);

    // Update the rating
    setRating(star);

    // Log the current rating after it is updated
    Konsole.log("Current rating:", star);
  };

  // Handle form submit
  const handleSubmit = async () => {
    // console.log("Review Submitted:", { rating, review });


    const jsonObj = {
      store_id: orderDetail?.store_id,
      rating: rating || 5,
      review: review || '',
      order_id: orderDetail?.order_item_id,
    };
    Konsole.log("jsonObj", orderDetail, jsonObj);

    setLoading(true);
    const _res = await reviewAddApi(jsonObj);
    setLoading(false);
    if (_res) {
      getOrder();
      getAllReview(dispatch, orderDetail?.store_id);
      getStoreInfo()
      handleModalOpenClose(false);
    }
    Konsole.log("_res_res", _res);
  };


  async function getOrder() {
    // setLoading(true);
    const { order_list } = await GetAllOrderApi();

    Konsole.log("order_list", order_list);
    dispatch(SETALLORDERDATA(order_list));
    // setLoading(false);
  }

  // Function to render filled or empty star
  const renderStar = (star: number) => {
    return (
      <svg
        onClick={() => handleRating(star)} // Log the star click event
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1024 1024"
        width="40px"
        height="40px"
        style={{
          cursor: "pointer",
          fill: star <= rating ? "rgb(255, 180, 0)" : "white", // Yellow for filled, white for empty
          stroke: star <= rating ? "none" : "rgb(255, 180, 0)", // Yellow border for empty stars
          strokeWidth: star <= rating ? "0" : "100", // 10px solid yellow border for empty stars
          marginRight: "5px",
        }}
      >
        <path d="M913.594 430.417c0-21.479-16.636-37.583-43.854-42.125l-218.354-31.771-97.719-197.604c-6.689-17.271-22.588-29.564-41.513-30.908l-0.154-0.009c-18.97 1.306-34.8 13.474-41.408 30.279l-0.113 0.325-97.865 197.917-218.656 31.812c-32.115 5.146-43.552 25.125-43.552 42.083 1.071 14.784 7.729 27.834 17.848 37.195l0.037 0.034 158.313 153.958-37.635 218.937c-0.574 3.351-0.932 7.246-0.989 11.214l-0.001 0.057c-0.075 0.932-0.118 2.019-0.118 3.115 0 22.532 18.142 40.826 40.616 41.072l0.023 0c10.422-0.285 20.107-3.195 28.492-8.090l-0.283 0.153 195.292-102.646 194.49 102.208c8.279 5.080 18.263 8.168 28.953 8.374l0.057 0.001c22.252-0.111 40.247-18.175 40.247-40.442 0-1.319-0.063-2.623-0.186-3.909l0.013 0.164c0.009-0.443 0.014-0.966 0.014-1.489 0-3.979-0.285-7.892-0.836-11.719l0.052 0.437-37.407-217.458 158.052-154.125c10.466-9.137 17.29-22.217 18.139-36.899l0.007-0.142z"></path>
      </svg>
    );
  };
  return (
    <>
      {location.pathname == "/review" && (
        <div className="topheader md:hidden block">
          <div className="pageHeader flex gap-2 items-center font-semibold">
            <BackButton to="/menu" />
            {t("Review.review")}
          </div>
        </div>
      )}
      {/* @@ START this block for Display all Reviews */}
      {refrencePage == reviewRefrencePageArr[0] ? (
        <>
          <ReviewList />
        </>
      ) : null}

      {/* @@ END this block for Display all Reviews */}

      {/* @@ START this block for add review and edit and delete review from order */}
      {refrencePage == reviewRefrencePageArr[1] ? (
        <>
          <p
            onClick={(e) => {
              e.stopPropagation();
              if (orderDetail?.review && Object?.keys(orderDetail?.review)?.length > 0) {
                return;
              }
              handleModalOpenClose(true);
            }}
            className="cursor-pointer text-black text-lg font-medium"
          >
            {orderDetail?.review &&
              Object?.keys(orderDetail?.review)?.length > 0 ? (
              <button className="text-blue text-center rounded-lg p-1  w-full font-bold text-base">
                {t("Review.youRated")} {orderDetail?.review?.rating || 0}{" "}
                <i key={`full`} className="fa fa-star text-yellow-500" />
                {/* <RenderStars rating={orderDetail?.review?.rating} /> */}
                {/* <i className="fa fa-edit ms-1"></i> */}
              </button>
            ) : (
              <button className="bg-red-700 textMd  text-white px-3 py-0 flex gap-2 items-center">
                {/* <i className="fa fa-star text-yellow-300 text-xl"></i> */}
                <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" color="#000000"><title>Star</title><path d="M23.917 8.5 16.104 8l-3.646-7-3.646 7L1 8.5 6.73 14l-2.084 8 7.812-4 7.813 4-2.084-8 5.73-5.5Zm-8.855 4.7L16 16.8 12.458 15l-3.541 1.8.937-3.6-2.5-2.4 3.23-.2L12.457 7l1.875 3.6 3.23.2-2.5 2.4Z" fill="currentColor"></path></svg>
                <div>
                  <p className="font-bold">{t("MyOrders.giveRating")}</p>
                  {/* <p className="font-normal">+91 1234567890</p> */}
                </div>
              </button>
            )}
          </p>
        </>
      ) : null}
      {/* @@ Modal for add and edit review */}
      <Modal
        open={IsModalOpen}
        onClose={() => handleModalOpenClose(false)}
        center
        classNames={{
          overlay: "customOverlay",
          modal: "modalMd scroll-hidden mobile-review",
          closeIcon: "modal-close",
        }}
        styles={{
          modal: { height: "auto", maxHeight: "400px", padding: "20px" }, // Adjust modal height
        }}
      >
        <div className="flex flex-col gap-4 p-5">
          {/* Step 1: 5 Star Rating */}
          <div className="flex items-center">
            {[1, 2, 3, 4, 5].map((star) => renderStar(star))}
          </div>

          {/* Step 2: Review Input */}
          <textarea
            className="w-full h-32 border border-gray-300 rounded-md p-2"
            placeholder={t("MyOrders.writeYourReviewHere")}
            value={review}
            onChange={(e) => setReview(e.target.value)}
          />

          {/* Step 3: Send Feedback Button */}
          <div className="flex justify-center w-50">

            <GlobalButton label={t("Review.sendFeedback")} onClick={handleSubmit} loading={loading} />
          </div>
        </div>
      </Modal>

      {/* @@ END this block for add review and edit and delete review from order */}
    </>
  );
};

export default AllReview;
